module.exports = __webpack_public_path__ + "static/stanford.3488665a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/highered_logos/stanford.png
// module id = 2199
// module chunks = 61762850755587